import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeStep } from "../store/settings/settingsSlice";
import { updateRegistrant } from "../store/registrant/registrantSlice";
import BallotRequestConfirmationForm from "../Forms/BallotRequestConfirmationForm";
import BackButton from "../Components/BackButton";
import { generateRegistrationID, createFormPayload, createImagePayload, sendSurveyData, getPublicKey } from '../services/api/voter';
import Bugsnag from '@bugsnag/js';
import { getContent } from "../content";

function BallotRequestConfirmation() {
    const partner = useSelector((state) => state.partner);
    const registrant = useSelector((state) => state.registrant);
    const information = useSelector((state) => state.information);
    const tracking = useSelector((state) => state.tracking);
    const currentLanguage = useSelector((state) => state.settings.currentLanguage);

    const [isSubmitting, setIsSubmitting] = React.useState(false);

    let navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(changeStep([5, 6]));
    }, []);

    const onSubmit = async (data) => {
        dispatch(updateRegistrant({
            ballot_request_confirmed: data.ballot_request_confirmed
        }));

        navigate('/had-assistance');
    };

    return (
        <section className="flex flex-col gap-4">
            <div className="">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="my-4 md:mt-8 lg:mt-16">{getContent('ballot_request.confirmation_heading')}</h2>
            </div>
            <div className="">
                <div className="p-8 border-4 rounded-lg border-evcpa-darkpurple max-h-[25vh] h-[25vh] overflow-scroll" dangerouslySetInnerHTML={{ __html: information.mailinDeclaration[currentLanguage] }}></div>
                <BallotRequestConfirmationForm submit={onSubmit} disabled={isSubmitting} />
            </div>
        </section>
    );
}

export default BallotRequestConfirmation;